import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6">
      <h1 className="text-4xl font-bold mb-4">404 — Page not found</h1>
      <p className="mb-6 text-center">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link to="/" className="px-4 py-2 bg-blue-600 text-white rounded">
        Go home
      </Link>
    </div>
  );
};

export default NotFound;
